// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__DataTableSearchBar__input__rrt9eo{width:var(--JDS-DATA-TABLE-HEADER-ACTIONS-CONTROLS-SEARCH-FIELD-WIDTH,200px)}", "",{"version":3,"sources":["webpack://./../../platform/@jutro/components/components/DataTable/components/DataTableSearchBar/DataTableSearchBar.module.css"],"names":[],"mappings":"AAAA,wCACE,4EAAA","sourcesContent":[".input {\n  width: var(--JDS-DATA-TABLE-HEADER-ACTIONS-CONTROLS-SEARCH-FIELD-WIDTH, 200px);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": "jut__DataTableSearchBar__input__rrt9eo"
};
export default ___CSS_LOADER_EXPORT___;
